import { createBlock as r, openBlock as i, unref as a, withCtx as o, renderSlot as l } from "vue";
import { useTracking as c } from "../../../composables/useTracking.js";
/* empty css                       */
import d from "../../../_virtual/_plugin-vue_export-helper.js";
import p from "../../../utils/validators/link.js";
import s from "../../../atoms/anchor-element/anchor-element.vue.js";
const u = "DsClickableWrapper", m = /* @__PURE__ */ Object.assign({
  name: u
}, {
  __name: "clickable-wrapper",
  props: {
    link: {
      type: Object,
      required: !0,
      validator: p
    }
  },
  setup(e) {
    const { trackingDataProvided: t } = c();
    return (n, k) => (i(), r(a(s), {
      class: "ds-card--clickable",
      url: e.link.url,
      "open-in-new-window": e.link.openInNewWindow,
      nuxt: e.link.nuxt,
      "aria-label": e.link.title,
      "tracking-data": { ...a(t) }
    }, {
      default: o(() => [
        l(n.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["url", "open-in-new-window", "nuxt", "aria-label", "tracking-data"]));
  }
}), v = /* @__PURE__ */ d(m, [["__scopeId", "data-v-d56c6834"]]);
export {
  v as default
};
